import React, { useEffect, useState } from "react";
import gigImage from "../../assets/images/gigimage.svg";
import { useSnackbar } from "notistack";
import OBCApi from "../../api/api";

export default function QuestsList({
  renderdomain_tagsWithDynamicLimit,
  openQuestModal,
}) {
  const [showLoading, setShowLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const showErrorSnack = (message) => {
    enqueueSnackbar(message, {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 3000,
    });
  };
  const showSuccessSnack = (message) => {
    enqueueSnackbar(message, {
      variant: "success",
      preventDuplicate: true,
      autoHideDuration: 3000,
    });
  };
  const [cardsData, setCardsData] = useState([
  ]);
  useEffect(() => {
    setShowLoading(true);
    const api = new OBCApi();
    api
      .getQuests()
      .then((res) => {
        setShowLoading(false);
        console.log(res.data.data);
        setCardsData(res.data.data.quests); //hard coded data for the time being
      })
      .catch((err) => {
        setShowLoading(false);
        showErrorSnack(err);
      });
  }, []);

  return (
    <div className=" orgpage_main_infocontainer_cardscontainer">
      <div className=" orgpage_main_infocontainer_cardscontainer_cards">
        {cardsData.map((card, index) => (
          <div
            key={index}
            className="orgpage_main_infocontainer_cardscontainer_cards_card"
          >
            <div className="orgpage_main_infocontainer_cardscontainer_cards_card_top">
              <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left">
                <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details">
                  <div
                    className={`orgpage_main_infocontainer_cardscontainer_cards_card_right_submission ${
                      card.status === "active" ? "open" : "closed"
                    }`}
                  >
                    {card.status === "active"
                      ? "Submissions Open"
                      : "Submissions Closed"}
                  </div>

                  <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details_name">
                    {" "}
                    {card.name}
                  </div>
                  {/* <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details_by">
                          by {card.createdBy}
                        </div> */}
                  <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details_desc">
                    {" "}
                    {card.description}
                  </div>
                </div>
              </div>
              <div className="orgpage_main_infocontainer_cardscontainer_cards_card_right">
                <div className="orgpage_main_infocontainer_cardscontainer_cards_card_right_buttoncontainer">
                  <div className="orgpage_main_infocontainer_cardscontainer_cards_card_right_buttoncontainer_button">
                    Edit
                  </div>
                  <div
                    onClick={() => openQuestModal(card)}
                    className="orgpage_main_infocontainer_cardscontainer_cards_card_right_buttoncontainer_button"
                  >
                    View Submissions
                  </div>
                </div>

                {/* <div className="orgpage_main_infocontainer_cardscontainer_cards_card_right_date">
                    Application ends on {(card.expiryDate)}
                  </div> */}
              </div>
            </div>
            <div>
              <div className="orgpage_main_infocontainer_cardscontainer_cards_card_bottom">
                <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details_top">
                  <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details_top_type">
                    {card.limit === -1
                      ? "Unlimited Submissions"
                      : `First ${card.limit} submissions`}
                  </div>
                  <div className="orgpage_main_infocontainer_cardscontainer_cards_card_left_details_top_amount">{`ZXP ${card.rewardXp}`}</div>
                </div>
                <div className="orgpage_main_infocontainer_cardscontainer_cards_card_right_tags">
                  {renderdomain_tagsWithDynamicLimit(card.tags, 30)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
